import { useState } from "react";
import { motion } from "framer-motion";
import { Mail, Palette } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", type: "custom_design", message: "" });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent! We'll be in touch soon.");
      setForm({ name: "", email: "", type: "custom_design", message: "" });
    } catch {
      toast.error("Could not send message");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="contact-page">
      <section className="border-b-2 border-[#1C1C1C] bg-[#F5F2EA] grain relative overflow-hidden">
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-20 relative">
          <Palette className="w-10 h-10 text-[#D35400] mb-4" strokeWidth={2.2} />
          <h1 className="font-display text-6xl md:text-7xl">Custom Designs & Contact</h1>
          <p className="text-lg text-[#4A4A4A] mt-3 max-w-2xl">
            Got an idea for a custom tee, a bulk order for your bar or business, or just want to say hey? Drop us a line.
          </p>
        </div>
      </section>

      <div className="max-w-2xl mx-auto px-6 py-16">
        <form onSubmit={submit} className="border-2 border-[#1C1C1C] hard-shadow bg-[#F5F2EA] p-8 space-y-5" data-testid="contact-form">
          <div>
            <label className="font-display text-xl">Name</label>
            <input required name="name" value={form.name} onChange={onChange} className="w-full mt-1 px-4 py-3 border-2 border-[#1C1C1C] bg-white focus:outline-none focus:border-[#D35400]" data-testid="contact-name" />
          </div>
          <div>
            <label className="font-display text-xl">Email</label>
            <input required type="email" name="email" value={form.email} onChange={onChange} className="w-full mt-1 px-4 py-3 border-2 border-[#1C1C1C] bg-white focus:outline-none focus:border-[#D35400]" data-testid="contact-email" />
          </div>
          <div>
            <label className="font-display text-xl">What's this about?</label>
            <div className="flex flex-wrap gap-2 mt-2">
              {[{ v: "custom_design", l: "Custom Design" }, { v: "general", l: "General" }].map((o) => (
                <button
                  key={o.v}
                  type="button"
                  onClick={() => setForm({ ...form, type: o.v })}
                  data-testid={`contact-type-${o.v}`}
                  className={`px-5 py-2 border-2 border-[#1C1C1C] font-bold transition-all ${form.type === o.v ? "bg-[#1C1C1C] text-[#FDFBF7]" : "hover:bg-[#EDE8DD]"}`}
                >
                  {o.l}
                </button>
              ))}
            </div>
          </div>
          <div>
            <label className="font-display text-xl">Message</label>
            <textarea required name="message" rows={5} value={form.message} onChange={onChange} placeholder="Tell us about your design idea, quantity, deadline…" className="w-full mt-1 px-4 py-3 border-2 border-[#1C1C1C] bg-white focus:outline-none focus:border-[#D35400] resize-none" data-testid="contact-message" />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full px-8 py-4 inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="contact-submit">
            <Mail className="w-5 h-5" /> {loading ? "Sending…" : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
